import loadable from '@loadable/component';

import './DeleteProfile.css';

export default loadable(() => {
  return import('./DeleteProfile.jsx');
});
